import React from "react";

import ShSlider from "../../../components/slider/shSlider";
import { SwiperSlide } from "swiper/react";




const Slider = ( { children, title, loop="false" } ) => {

    if (!children) {
        return null;
    }

    if(loop === "true"){
        loop = true;
    } else {
        loop = false;
    }

    return <ShSlider className="mt-5" caption={title} loop={loop}>
        { children.map( (d, i) => {

            if (!d) {
                return null;
            }
            return <SwiperSlide key={i} className="mw-card">
                    {d}
                </SwiperSlide>;

        })}
    </ShSlider>

};

export default Slider;
